import React, { useState } from 'react';
import AdminAppBody from '../../../../components/admin/AdminAppBody';
import { FaEye } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const assessments = [
  { id: 1, title: 'Beginner-Level React Assessment', difficulty: 'Beginner', totalQuestions: 5 },
  { id: 2, title: 'Beginner-Level React Assessment', difficulty: 'Beginner', totalQuestions: 5 },
  { id: 3, title: 'Intermediate Assessment on Python Basics', difficulty: 'Intermediate', totalQuestions: 10 },
  { id: 4, title: 'Basic Programming Assessment', difficulty: 'Beginner', totalQuestions: 5 },
  { id: 5, title: 'Beginner-Level React Assessment', difficulty: 'Beginner', totalQuestions: 10 }
];

const assignedStudents = {
  1: ['Yash Santosh Alhat'],
  2: ['Sneha Patil', 'Rohan Kale'],
  3: ['Amol Bhosale', 'Pooja Deshmukh'],
  4: ['Vikas Pawar'],
  5: ['Anjali Kulkarni']
};

const AssessmentsList = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedAssessment, setSelectedAssessment] = useState(null);

  const handleShowModal = (assessment) => {
    setSelectedAssessment(assessment);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedAssessment(null);
  };

  return (
    <AdminAppBody content={
      <div className="container mt-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h3>Assessments Created by You</h3>
          <Link to="/mentor-assessments/add"><button className="btn btn-primary">
            <i className="bi bi-plus-lg me-2"></i>+ New Assessment
          </button></Link>
          
        </div>

        <div className="table-responsive">
          <table className="table table-bordered table-hover">
            <thead className="table-primary">
              <tr>
                <th>Sr No</th>
                <th>Assessment Title</th>
                <th>Difficulty</th>
                <th>Total Questions</th>
                <th>View</th>
              </tr>
            </thead>
            <tbody>
              {assessments.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>{item.title}</td>
                  <td>{item.difficulty}</td>
                  <td>{item.totalQuestions}</td>
                  <td>
                  <button className="sys-list-table__action view" onClick={() => handleShowModal(item)}>
  <FaEye className="me-1" /> View
</button>

                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Custom Modal (No external components used) */}
        {showModal && (
          <div className="modal d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">{selectedAssessment?.title} - Details</h5>
                  <button type="button" className="btn-close" onClick={handleCloseModal}></button>
                </div>
                <div className="modal-body">
                  <h6 className="fw-bold">Assigned Students:</h6>
                  <ul>
                    {(assignedStudents[selectedAssessment?.id] || []).map((student, idx) => (
                      <li key={idx}>{student}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    } />
  );
};

export default AssessmentsList;
